// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"420":"ba7ba7c9","625":"ba7ba7c9","748":"e7f260ed","750":"ba7ba7c9"}[chunkId] + ".chunk.css";
};